import {Injectable} from '@angular/core';
import {State} from '../model/state.model';
import {ConfigService} from './config.service';
import {HttpClient} from '@angular/common/http';
import {AbstractSettingsService} from './abstract-settings.service';

@Injectable()
export class StateService extends AbstractSettingsService {
    constructor(httpClient: HttpClient, configService: ConfigService) {
        super(httpClient, configService);
    }

    public async getAll(): Promise<State[]> {
        const settings = await this.getSettings();
        return settings.state_list.map(state => (<State>{name: state.state_name}));
    }
}
